/**
 * Vimeo → GA4 play tracking
 * Sends video_start, video_progress (25/50/75/90%), and video_complete
 * for Vimeo videos added with the Gutenberg embed block. Works with gtag.js
 * or Google Tag Manager.
 *
 * Requires the Vimeo Player SDK (https://player.vimeo.com/api/player.js)
 * to load first; see the enqueue snippet in functions-snippet.php.
 */
(function () {
  'use strict';

  var MILESTONES = [25, 50, 75, 90];

  // Send to gtag if it's on the page, otherwise push to the GTM dataLayer.
  function send(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
    }
  }

  function track(iframe) {
    if (iframe.dataset.vimeoTracked) return; // avoid double-binding
    iframe.dataset.vimeoTracked = 'true';

    var player = new window.Vimeo.Player(iframe);

    // Episode label comes from the wrapping section's id (episode-1, episode-2…)
    var section = iframe.closest('[id^="episode-"]');

    var base = {
      video_provider: 'vimeo',
      video_url: iframe.src.split('?')[0],
      video_title: '',
      episode: section ? section.id : '(none)'
    };

    player.getVideoTitle()
      .then(function (title) { base.video_title = title; })
      .catch(function () {});

    var started = false;
    var sent = {};

    player.on('play', function () {
      if (started) return; // count the first play only, not every resume
      started = true;
      send('video_start', Object.assign({}, base, { video_percent: 0 }));
    });

    player.on('timeupdate', function (data) {
      var pct = Math.floor(data.percent * 100);
      MILESTONES.forEach(function (m) {
        if (pct >= m && !sent[m]) {
          sent[m] = true;
          send('video_progress', Object.assign({}, base, { video_percent: m }));
        }
      });
    });

    player.on('ended', function () {
      if (sent[100]) return;
      sent[100] = true;
      send('video_complete', Object.assign({}, base, { video_percent: 100 }));
    });
  }

  function init() {
    if (!window.Vimeo || !window.Vimeo.Player) return;
    // Only Vimeo videos from the Gutenberg embed block, so videos
    // from ACF fields or templates on the same page aren't tracked.
    document
      .querySelectorAll(
        '.wp-block-embed-vimeo iframe[src*="player.vimeo.com"], ' +
        '.is-provider-vimeo iframe[src*="player.vimeo.com"]'
      )
      .forEach(track);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
